import { useState } from "react";
import { toast } from "react-toastify";
import { exportReleases } from "@services/releases/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { getStatusLabel } from "@utils/translator/releases";
import { RELEASES_EXPORT_HEADS } from "@typings/entities/releases/export";
import type { ReleasesFilters } from "@services/releases/list/type";

export function useExportReleases() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (filters?: ReleasesFilters) => {
    setIsLoading(true);
    try {
      const response = await exportReleases(filters);

      if (!response.items?.length) {
        toast.warning("Nenhum dado de solturas disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        status: getStatusLabel(item.status),
        approvedDate: formatDateTime(item.approvedDate),
        expectedDate: formatDateTime(item.expectedDate),
        lastStatusDate: formatDateTime(item.lastStatusDate),
        executionDate: formatDateTime(item.executionDate),
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(
        translatedData,
        RELEASES_EXPORT_HEADS,
      );
      exportToCSV(formattedData, `relatorio_solturas_${actualDateTime()}`);
      toast.success("Relatório de solturas exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de solturas");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
